import React, { useState } from "react";
import "./LabeledMedia.css";
import "../../index.css";


const LabeledMedia = ({
  src,
  alt = "",
  video = false,
  labelComponent = null,
  bg = null,
  categorical = false,
  styleOverride = null, 
  class_Name = "",
  onClick = null,

}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div 
      className={`labeled-media ${categorical ? "borders-gray-vertical" : ""} ${onClick ? "clickable" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {/* Loader (optional simple placeholder) */}
      {!loaded && <div className= {`media-placeholder ${bg && bg}`} />}

      {video ? (
        <video
          className={`media ${loaded ? "visible" : "hidden"}`}
          src={src}
          loop
          autoPlay
          muted
          playsInline
          onLoadedData={() => setLoaded(true)}
        />
      ) : (
        <img
          className={`media ${loaded ? "visible" : "hidden"}`}
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      )}

      {/* Overlay label component */}
      {labelComponent && (
        <div className="label-overlay">
          {labelComponent}
        </div>
      )}
    </div>
  );
};

export default LabeledMedia;